import { render } from "./Sucursal-Component.vue?vue&type=template&id=d3309164&scoped=true"
import script from "./Sucursal-Component.vue?vue&type=script&lang=js"
export * from "./Sucursal-Component.vue?vue&type=script&lang=js"

import "./Sucursal-Component.vue?vue&type=style&index=0&id=d3309164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3309164"]])

export default __exports__